import type { FuncOverrideComponent } from '../theme.types';

export const MuiSvgIcon: FuncOverrideComponent<'MuiSvgIcon'> = theme => ({
  styleOverrides: {
    root: {
      color: theme.palette.primary.main,
    },
  },
});
